import { useState } from "react"
import { useDataTypesHooks, INITIAL_SORT_STATE, SortState, nextSortState, sortRows, withSortHeaders } from "../../../../../features/data-types"
import { Table, Column, Data, FieldType, FieldValue, Section } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useFind } from "../../../../../state/reducers/hooks"
import { useMemo } from "react"

type Props = {
    rows: Data[]
    readOnly?: boolean
    onAdd?: () => void
    onEditRow?: (catgoryId: string) => void
    onRemoveRow?: (catgoryId: string) => void
}

export const CategorySaleYieldsTable = (props: Props) => {
    const { rows, readOnly, onAdd, onEditRow, onRemoveRow } = props

    const { formatValue } = useDataTypesHooks()
    const find = useFind()

    const [sortState, setSortState] = useState<SortState>(INITIAL_SORT_STATE)
    const onColumnSort = (name: string) => setSortState(prev => nextSortState(prev, name))

    const columns: Column[] = [
        {
            name: 'categoryId',
            type: FieldType.TABLE,
            table: TableName.CATEGORIES,
            label: 'Categoría',
            sortValue: (value?: FieldValue) => (find(TableName.CATEGORIES, value as string) as { name?: string })?.name ?? ''
        },
        {
            name: 'saleYield',
            type: FieldType.PERCENTAGE,
            label: 'Rentabilidad',
            sortValue: (value?: FieldValue) => value == null ? 0 : Number(value),
            render: (value?: FieldValue) => <>{formatValue(value, FieldType.NUMBER)}%</>
        }
    ]

    const sortedRows = useMemo(() => {
        if (!sortState.column || !sortState.direction) return rows
        const col = columns.find(c => c.name === sortState.column)
        if (!col) return rows
        return sortRows(rows, col, sortState.direction)
    }, [rows, sortState])

    const sortableColumns = withSortHeaders(columns, sortState, onColumnSort)

    return (
        <Section
            id='categorySaleYields'
            space={12}
        >
            <Table
                columns={sortableColumns}
                rows={sortedRows}
                rowId='categoryId'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onAdd}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
